(function($) {
	
	//'use strict';
	var win = $(window);
	var savePDFPopupBtn;
	var savePDFBtn;
	var savePopup;
	var savePopupClose;
	var saveForm;
	var deleteSavedFormBtn;
    
    var openSaveForm = function(){
		$("#blackout").css("display", "block");
		savePopup.addClass("open");
    };
    
    var closeSaveForm = function(){
		$("#blackout").css("display", "none");
		savePopup.removeClass("open");
    };
    
    var compileValues = function() {
        var lang = saveForm.find("[name=lang]").val();
        var chapterInputs = $(".chapterHandlesInput:checked", saveForm);
        var newChapterString = "";
        var subchapterInputs = saveForm.find(".subchapterHandlesInput:checked");
        var subchapterList = "";
        var showSubChapters = saveForm.find("[name=showSubChapters]").val();
        var regionList = "";
        var agglomerationList = "";
        var cityList = "";
        
        if (lang === "") {
            // Admin can have an option to select all languages by having the lang input empty
            lang = document.documentElement.lang;
        }
        
        chapterInputs.each(function() {
            if (newChapterString !== "") {
                newChapterString += ",";
            }
            newChapterString += $(this).val();
        });
        saveForm.find("[name='chapterHandles']").val(newChapterString);

        if (showSubChapters.length) {
            subchapterList = showSubChapters.val();
        } else {
            subchapterInputs.each(function() {
                if (subchapterList !== "") {
                    subchapterList += ",";
                }
                subchapterList += this.getAttribute("data-" + lang);
            });
        }
        saveForm.find("[name='subchapterHandles']").val(subchapterList);

        saveForm.find(".newrow .regionHandlesInput").each(function() {
            if (regionList !== "") {
                regionList += ", ";
            }
            regionList += this.value;
        });
        if (regionList === "") {
            regionList = "all";
        }
        saveForm.find("[name='field11']").val(regionList);
        
        saveForm.find(".newrow .agglomerationHandlesInput").each(function() {
            if (agglomerationList !== "") {
                agglomerationList += ", ";
            }
            agglomerationList += this.value;
        });
        if (agglomerationList === "") {
            agglomerationList = "all";
        }
        saveForm.find("[name='field12']").val(agglomerationList);
        
        saveForm.find(".newrow .cityHandlesInput").each(function() {
            if (cityList !== "") {
                cityList += ", ";
            }
            cityList += this.value;
        });
        if (cityList === "") {
            cityList = "all";
        }
        saveForm.find("[name='field13']").val(cityList);
        
        return {
            lang: lang,
            showSubChapters: showSubChapters,
            chapterHandles: newChapterString,
            subchapterHandles: subchapterList,
            field11: regionList,
            field12: agglomerationList,
            field13: cityList
        };
    };

    var saveFormAction = function(){
        var name = savePopup.find("input").val();
        if(name !== ""){
            if (!saveForm.find(".chapterHandlesInput.required:checked").length) {
                saveForm.find(".admin-form-chapter-ctn").addClass("has-error");
                return false;
            }
            
            var cover = saveForm.find("[name=coverFilename]").val();
            var fields = compileValues();
            var url = "lang=" + fields.lang;
            url += "&coverFilename=" + cover;
            url += "&chapterHandles=" + fields.chapterHandles;
            url += "&subchapterHandles=" + fields.subchapterHandles;
            url += "&field11=" + fields.field11;
            url += "&field12=" + fields.field12;
            url += "&field13=" + fields.field13;
            url += "&name=" + name;
            url += "&save=true";
            
            $.post("/action/crgm", url, function(response){
                location.reload();
            });
            
        } else {
            savePopup.find("input").addClass("error");
        }
    };
    
    var deleteSavedForm = function(){
        var t = $(this);
        
        var confirm = window.confirm("\xCAtes-vous s\xFBr de vouloir supprimer cette sauvegarde ?");
        
        if(confirm){
            var url = "/action/manageGenData";
            url += "?ajax=true";
            url += "&delete=true";
            url += "&id="+t.attr("data-id");
            
            ajax(url, function(response){
                if(response.indexOf("success") !== -1){
                    t.closest(".admin-form-save").remove();
                }
            }, true);
        }
    };
    
    var submitForm = function (e) {
        e.preventDefault();
        if (saveForm.hasClass("processing")) {
            return;
        }
        
        if (!saveForm.find(".chapterHandlesInput.required:checked").length) {
            saveForm.find(".admin-form-chapter-ctn").addClass("has-error");
            return false;
        }
        
        var fields = compileValues();

        saveForm.addClass("processing");
        setTimeout(function() {
            saveForm.submit();
            if (saveForm.attr("target") === "_blank") {
                saveForm.removeClass("processing");
            }
        }, 200);
    };
    
    var selectChapters = function (e) {
        var $it = $(e ? e.currentTarget || this : this);
        var $ctn = $it.closest(".admin-form-chapter-inputs-ctn");
        var $subchapterInputs = $ctn.find(".subchapterHandlesInput");
        
        $subchapterInputs.prop("checked", $it.prop("checked"));
        saveForm.find(".admin-form-chapter-ctn.has-error").removeClass("has-error");
    };
    
    var selectSubchapters = function (e) {
        var $it = $(e ? e.currentTarget || this : this);
        var $ctn = $it.closest(".admin-form-chapter-inputs-ctn");
        var $chapterInput = $ctn.find(".chapterHandlesInput");
        var $subchapterInputs = $ctn.find(".subchapterHandlesInput");
        
        if ($it.prop("checked")) {
            $chapterInput.prop("checked", true);
            saveForm.find(".admin-form-chapter-ctn.has-error").removeClass("has-error");
        } else if ($subchapterInputs.filter(":checked").length === 0) {
            $chapterInput.prop("checked", false);
        }
    };
    
    var expandSubchapterList = function(e) {
        var $it = $(e ? e.currentTarget || this : this);
        var $targ = $it.closest(".admin-form-chapter-inputs-ctn").find(".admin-form-subchapter-list");
        
        $targ.slideDown(300).removeClass("collapsed");
        $it.hide();
    };

	win.load(function () {
        saveForm = $(".admin-form");
        savePopup = $(".popup-form-save");
        savePopupClose = $(".admin-form-save-cancel");
        savePDFPopupBtn = $(".admin-save-form-btn");
        savePDFBtn = $(".admin-final-save-form-btn");
        deleteSavedFormBtn = $(".admin-form-delete");
        
        savePDFPopupBtn.on("click", openSaveForm);
        savePopupClose.on("click", closeSaveForm);
        savePDFBtn.on("click", saveFormAction);
        deleteSavedFormBtn.on("click", deleteSavedForm);
        $(".admin-form-btn", saveForm).on("click", submitForm);
        $(".chapterHandlesInput", saveForm).on("change", selectChapters);
        $(".subchapterHandlesInput", saveForm).on("change", selectSubchapters);
        
        $(".admin-form-subchapter-expand-btn").on("click", expandSubchapterList);
	});
	
})(jQuery);